<template>
  <div class="cash-withdrawal">
    
    <div class="my-promotion">
        <div class="header" style="background-color: rgb(236, 93, 89) !important;">
            <!-- <div class="name acea-row row-center-wrapper">
                <div>累计转账</div>
            </div>
            <div class="num">{{total}}</div> -->
            <div class="name acea-row row-center-wrapper">
                <div v-if="post.accout==1">消费账户余额</div>
                <div v-if="post.accout==2">优先股账户余额</div>
            </div>
            <div class="num" v-if="post.accout==1">{{now_money}}</div>
            <div class="num" v-if="post.accout==2">{{f_money}}</div>
        </div>
    </div>


     <!--<div class="nav acea-row"> 
      <div
        v-for="(item, index) in navList"
        class="item font-color-red"
        @click="swichNav(index, item)"
        :key="index"
      >
        <div
          class="line bg-color-red"
          :class="currentTab === index ? 'on' : ''"
        ></div>
        <div
          class="iconfont"
          :class="item.icon + ' ' + (currentTab === index ? 'on' : '')"
        ></div>
        <div>{{ item.name }}</div>
      </div> 
    </div>-->
   <div class="bill-details">
        <div class="nav acea-row">
        <div class="item" :class="currentTab == 0 ? 'on' : ''" @click="swichNav(0)">
            转账
        </div>
        <div class="item" :class="currentTab == 1 ? 'on' : ''" @click="swichNav(1)">
            转账记录
        </div> 
        </div>
    </div>
    <div class="wrapper">
      <div :hidden="currentTab !== 0" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">转出账户</div>
          <div class="input">
            <select v-model="post.accout" placeholder="请选择账户" @change="accoutSelect"> 
              <option value="1">消费账户</option>
              <option value="2">优先股账户</option>
            </select>
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">转入账户</div>
          <div class="input">
            <select v-model="post.toaccout" placeholder="请选择转入账户" :disabled="isSelectDisabled">
              <option value="1">消费账户</option>
			  <option value="3">体验账户</option>
            </select>  
          </div>
        </div> 
        <div class="item acea-row row-between-wrapper">
          <div class="name">金额</div>
          <div class="input">
            <input
              :placeholder="'最低转账金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
		<div class="tip">
			<div v-if="post.accout==1">消费账户余额可以转到体验账户，体验账户只能消费不能再转出。</div>
			<div v-if="post.accout==2">优先股分红账户转账时间为3月1号，6月1号，9月1号，12月1号，转账一次到消费账户。</div> 
		</div>
	 
        <div class="bnt bg-color-red" @click="submitted">转账</div>
      </div>
      <div :hidden="currentTab !== 1">
        <div class="sign-record">
      <div class="list nopadding">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="data">{{ item.time }}</div>
          <div class="listn" v-for="(val, key) in item.list" :key="key">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.title }}</div>
                <div>{{ val.touser }}</div>
                <div>{{ val.add_time }}</div>
              </div>
              <div class="num" :class="val.pm == 0 ? 'font-color-red' : ''">
                {{ val.pm == 0 ? "-" : "+" }}{{ val.number }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
      </div> 
    </div>
  </div>
</template>
<script>

import { getBalance, postTransferCountInfo,getCommissionInfo,getUserByNo } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

export default {
  name: "UserTransferCount",
  components: {},
  props: {},
  data: function() {
    return {
      navList: [
        { name: "银行卡", type: "bank", icon: "icon-yinhangqia" },
        { name: "微信", type: "weixin", icon: "icon-weixin2" },
        { name: "支付宝", type: "alipay", icon: "icon-icon34" }
      ],
      post: {
        accout: "1",
        toaccout: "3",
        money: "",
        code:""
      },
	  isSelectDisabled:true,
      d_money:0,
      now_money:0,
	  f_money:0,
      total:0,
      currentTab: 0,
      minPrice: 100,
      banks: [], 
      real_name:'',
      where: {
        page: 1,
        limit: 10
      },
      list: [],
      loaded: false,
      loading: false,
      types:"8"
    };
  },
  mounted: function() {
    this.getBank();
    //this.getList();
  },
  methods: {
	accoutSelect(event) {
		let that = this;
	    console.log('选择的值:', that.post.accout);
		if(that.post.accout=="1"){
			that.post.toaccout="3";
		}else{
			that.post.toaccout="1";
		}
	    // 你可以在这里添加更多逻辑来处理选择事件
	},
    swichNav: function(index) {
      let that = this;
      this.currentTab = index;
      if(index==1){
        that.where.page=1;
        that.list=[];
        this.getList();
      }
    },
    zhituiChange:function(){
		let $id=this.post.username;
		this.getTuiJianRen($id);
	},
	getTuiJianRen: function(id) {
	  let that = this;
	  getUserByNo(id).then(res => {  
		  if(typeof res.data === 'object' && res.data !== null && !Array.isArray(res.data)){  
			that.real_name=res.data.real_name;
		  }else{
			  that.real_name="不存在";
			  this.$dialog.message('不存在用户，请检查！');
		  }
	  });
	},
    getList:function(){
        let that = this;
        getCommissionInfo(that.where, that.types).then(
            res => {
            that.loading = false;
            that.loaded = res.data.length < that.where.limit;
            that.where.page = that.where.page + 1;
            that.list.push.apply(that.list, res.data);
            },
            error => {
            that.$dialog.message(error.msg);
            }
        );
    },
    getBank: function() {
      let that = this;
      getBalance().then(
        res => {
          that.now_money = res.data.now_money;
          //that.minPrice = res.data.minPrice;
          that.d_money = res.data.d_money;
		  that.f_money = res.data.f_money;
          that.total = res.data.total_transfer;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    async submitted() {
      let accout = this.post.accout,
        code = this.post.code,
        money = this.post.money,
        toaccout = this.post.toaccout, 
        that = this;
        let commissionCount=0;
        if(accout==1){
            commissionCount=that.now_money;
        }else if(accout==2){
            commissionCount=that.f_money;
        }
        if (
            parseFloat(money) > parseFloat(commissionCount) ||
            parseFloat(commissionCount) == 0
        )
        return that.$dialog.message("余额不足");
      if (parseFloat(money) < parseFloat(that.minPrice))
        return that.$dialog.message("最低转账金额" + that.minPrice);
          try {
            await this.$validator({
              accout: [required.message("请选择转账账户")], 
              toaccout: [required(required("请输入转入用户"))],
              money: [required(required("请输入转入金额"))]
            }).validate({ accout, toaccout, money });
            let save = {
              accout: accout,
              toaccout: toaccout, 
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          } 
    },
    save: function(info) {
        postTransferCountInfo(info).then(
        res => {
          this.$dialog.message(res.msg); 
          let that=this;
          that.post.code="";
          that.post.money="";
          
          //setTimeout(() => {
            this.getBank();
            that.where.page=1;
            that.list=[];
            this.getList();
            that.currentTab=1;
         // }, 1000);
          
          //location.reload();
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>

<style scoped>
   .list .item{ position: relative;}
   .cash-withdrawal .wrapper .list .item{ min-height: 1.07rem; height: auto;}
   .tips{width: 3em;
    font-size: .32rem;
    margin-left: 0.2rem;
    text-align: right;
	position: absolute;
	right: 0.1rem;
	bottom: 0.2rem;
	}
    .cash-withdrawal .wrapper .nopadding{ padding: 0;}
</style>
